/* Theme css - ModernHaus-SoHo */


import { StyleSheet } from 'react-native';



export const theme = {

  PRIMARY_FONT_LIGHT: {
    fontFamily: 'SangBleuSans-Light',
    fontWeight: 300,
  },
  PRIMARY_FONT: {
    fontFamily: 'SangBleuSans-Regular',
    fontWeight: 400,
  },
  SECONDARY_FONT: {
    fontFamily: 'RidleyGrotesk-Regular',
    fontWeight: 400,
  },

  FONT_XSMALL: {
    fontSize: 10,
  },
  FONT_SMALL: {
    fontSize: 12,
    lineHeight: 18,
  },
  FONT_MEDIUM: {
    fontSize: 14,
    lineHeight: 18,
  },
  FONT_LARGE: {
    fontSize: 18,
    letterSpacing: 0.36,
    lineHeight: undefined
  },
  FONT_XLARGE: {
    fontSize: 24,
    lineHeight: undefined
  },
  FONT_XXLARGE: {
    fontSize: 24,
    lineHeight: undefined
  },

  COLORS: {
    WHITE: "#ffffff",
    BLACK: "#000000",

    BACKGROUND_COLOR: '#D6D2C4', // background color for main containers
    BACKGROUND_COLOR_CONTRAST: '#002B49',

    BACKGROUND_COLOR_SECONDARY: "#002B49", // secondary background color (eg: footer)
    BACKGROUND_COLOR_SECONDARY_CONTRAST: "#FFFFFF",

    PRIMARY_COLOR: "#D6D2C4", // primary color
    PRIMARY_TEXT_COLOR: "#002B49", // primary text color

    SECONDARY_COLOR: "#002B49", // secondary color
    SECONDARY_TEXT_COLOR: "#FFFFFF", // secondary text color

    ACCENT_COLOR: "#FCD299",
    ACCENT_Text_COLOR: "#002B49"
  },
};


export default StyleSheet.create({

  welcomeScreenPrimaryBtn: {
    backgroundColor: theme.COLORS.ACCENT_COLOR,
  },
  welcomeScreenPrimaryBtnTxt: {
    color: theme.COLORS.ACCENT_Text_COLOR,
  },

  
  primaryBtn: {
    borderRadius: 0,
  },
  primaryBtnTxt: {
    fontSize: 14,
    lineHeight: 18
  },
  secondaryBtn: {
    borderRadius: 0
  },
  secondaryBtnTxt: {
    fontSize: 14,
    lineHeight: 18
  },
  tertiaryBtn: {
    borderRadius: 0,
  },
  tertiaryBtnTxt: {
    fontSize: 14,
    lineHeight: 18
  },

  input: {
    borderRadius: 0,
    selectionColor: "#002B49"
  },

  Dropdown: {
    borderRadius: 0,
  },
  dropdown_web: {
    borderRadius: 0,
  },

  mainContainerHeaderContainer: {
    display: "none"
  },

  floatingWidgetMainContainer: {
    backgroundColor: theme.COLORS.SECONDARY_COLOR,
  },

  headerContainer: {
    backgroundColor: theme.COLORS.SECONDARY_COLOR,
  },
  headerContainerLogo: {
    height: 30,
    width: 118
  },
  headerContainerWithBack: {
    backgroundColor: theme.COLORS.SECONDARY_COLOR,
  },

  backText: {
    color: theme.COLORS.SECONDARY_TEXT_COLOR,
  },
  backIcon: {
    filter: "invert(1)",
    tintColor: theme.COLORS.SECONDARY_TEXT_COLOR,
  },

  notificationIcon: {
    filter: "invert(1)",
    tintColor: theme.COLORS.SECONDARY_TEXT_COLOR,
  },

  promoWidgetContainer: {
    minHeight: 222,
    height: 222
  },

  smallIconMultipleWidgetContainer_muti_special_widget: {
    position: "absolute",
    height: 222,
    justifyContent: "flex-end",
  },
  smallIconMultipleWidgetItemsMainContainer_muti_special_widget: {
    backgroundColor: "#002B49BF",
    borderWidth: 1,
    borderColor: "#FFFFFF66",
  },
  smallIconMultipleWidget_WidgetsTitleText_muti_special_widget: {
    color: "#D6D2C4"
  },

  smallIconMultipleWidget_WidgetsContainer_muti_special_widget_center: {
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderLeftColor: '#FFFFFF66',
    borderRightColor: '#FFFFFF66'
  },
  smallIconMultipleWidget_WidgetsTitleText_muti_special_widget_center: {
    color: "#D6D2C4"
  },


  smallIconMultipleWidgetTitleText: {
    textTransform: "uppercase",
  },
  smallIconMultipleWidgetDescriptionText: {
    ...theme.FONT_MEDIUM,
  },


  smallIconMultipleWidgetTitleContainer_full_width: {
    display: "flex",
    marginBottom: 16,
  },
  smallIconMultipleWidget_WidgetsContainer_full_width: {
    height: "auto",
    borderWidth: 0,
    paddingHorizontal: 0,
    paddingVertical: 0
  },
  smallIconMultipleWidget_WidgetsImg_full_width: {
    height: "auto",
    width: "100%",
    aspectRatio: 375 / 114,
    maxHeight: 333,
    objectFit: "contain",
    resizeMode: "contain"
  },
  smallIconMultipleWidget_WidgetsTitleContainer_full_width: {
    position: "absolute",
    left: 16,
    bottom: 16
  },
  smallIconMultipleWidget_WidgetsTitleText_full_width: {
    textAlign: "left",
    color: theme.COLORS.WHITE,
    ...theme.FONT_LARGE
  },


  multipleLargeWidgetTitleText: {
    textTransform: "uppercase"
  },
  multipleLargeWidgetDescriptionText: {
    ...theme.FONT_MEDIUM
  },
  multipleLargeWidget_WidgetsTitleContainer: {
    height: "100%",
    justifyContent: "space-between"
  },
  multipleLargeWidget_WidgetsTitleText: {
    ...theme.PRIMARY_FONT_LIGHT,
    ...theme.FONT_LARGE,
  },
  multipleLargeWidget_WidgetsButtonContainer: {
    borderWidth: 1,
    borderBottomColor: undefined,
    borderColor: theme.COLORS.WHITE,
    width: "100%",
    height: 40,
    justifyContent: "center",
    alignItems: "center",
  },
  multipleLargeWidget_WidgetsButtonContainerText: {
    ...theme.PRIMARY_FONT,
    textAlign: "center",
    ...theme.FONT_SMALL,
    color: theme.COLORS.WHITE
  },
  multipleLargeWidget_ScrollTrack: {
    display: "flex",
    backgroundColor: "#94B7BB",
  },

  multipleSmallWidgetTitleText: {
    textTransform: "uppercase"
  },
  multipleSmallWidgetDescriptionText: {
    ...theme.FONT_MEDIUM
  },
  multipleSmallWidget_WidgetsImg: {
    borderRadius: 0,
  },
  multipleSmallWidget_WidgetsTitleText: {
    ...theme.PRIMARY_FONT_LIGHT,
  },
  multipleSmallWidget_WidgetsSubTitleText: {
    ...theme.FONT_XSMALL,
    textTransform: "uppercase"
  },

  bannerMultipleMultipleWidgetTitleText: {
    textTransform: "uppercase"
  },
  bannerMultipleMultipleWidgetDescriptionText: {
    ...theme.FONT_MEDIUM
  },
  bannerWidgetMultipleTitle: {
    ...theme.PRIMARY_FONT,
    textTransform: "uppercase"
  },

  promoWidgetContainer_dining: {
    display: "none"
  },

  infoWidgetImageStyle_res_dining: {
    height: "auto",
    width: "100%",
    maxHeight: 200,
    aspectRatio: 375 / 206,
    resizeMode: "cover",
    objectFit: "cover",
    marginHorizontal: "auto"
  },
  infoWidgetImageStyle_landscape_res_dining: {
    height: "auto",
    width: "100%",
    maxHeight: 350,
    aspectRatio: 375 / 206,
    resizeMode: "cover",
    objectFit: "cover",
    marginHorizontal: "auto"
  },


  tabContainerTopBorder_container: {
    display: "none"
  },
  tabLabelFocused: {
    color: theme.COLORS.ACCENT_COLOR,
  },

  tabContainerTopBorder_container_landscape: {
    display: "none"
  },
  tabLabelFocused_landscape: {
    color: theme.COLORS.ACCENT_COLOR,
  },


  guestDetailsDateContainer: {
    gap: 0,
    marginBottom: 0
  },
  guestDetailsDateItemContainer: {
    borderColor: "#154734",
    gap: 8,
    width: "100%",
    flex: 1
  },
  guestDetailsDateItemDurationContainer: {
    borderLeftWidth: 0,
    borderRightWidth: 0
  },
  guestDetailsDateItemTitle: {
    textTransform: "uppercase"
  },
  guestDetailsDateItemSubTitle: {
    ...theme.PRIMARY_FONT
  },

  guestrequest_childcontainer_itemContainer_arrow_img_selected: {
    filter: undefined,
    tintColor: theme.COLORS.BLACK
  },

  checkInDisclaimer_signature: {
    backgroundColor: theme.COLORS.WHITE
  },
  checkInDisclaimer_signature_canvas: {
    backgroundColor: theme.COLORS.WHITE
  }

});
